import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const benefits = [<>
    <strong data-id="element-12">Pan artesanal con miga real</strong> que se dobla sin romperse, dura
    tierno al día siguiente y puede ir al trabajo sin desmoronarse ✨
  </>, <>
    <strong data-id="element-13">Pasteles y budines perfectos</strong> que salen bien todas las
    veces, sin ese sabor a laboratorio que tienen los industriales 🍪
  </>, <>
    <strong data-id="element-14">Postres irresistibles</strong> que puedes llevar a cualquier reunión
    y nadie notará que no tienen gluten... ni tú 😍
  </>, <>
    <strong data-id="element-15">Librarte de los productos industriales caros</strong> y de mala
    calidad: el pack se paga solo en las primeras semanas 💰
  </>];
export function BenefitsSection() {
  return <section className="py-5 md:py-10 px-4 bg-brand-cream" data-id="element-16">
      <div className="max-w-3xl mx-auto" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-green text-white text-center py-5 px-6 rounded-xl mb-8 shadow-lg" data-id="element-18">
          <h2 className="text-2xl md:text-3xl font-heading font-bold uppercase tracking-wide" data-id="element-19">
            CON ESTO VAS A LOGRAR...
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-20">
          {benefits.map((content, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="bg-white p-6 md:p-8 rounded-xl shadow-sm border-l-[6px] border-brand-green text-center" data-id="element-21">
              <CheckCircle2 className="w-8 h-8 text-brand-green mx-auto mb-4" data-id="element-22" />
              <p className="text-lg text-brand-brownLight leading-relaxed [&_strong]:text-brand-brown" data-id="element-23">
                {content}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}